import { useApplicantCreditCheckSuggestion } from '../ApplicantCreditCheckBlock.hooks'
import { ApplicantCreditCheckSuggestion } from '../ApplicantCreditCheckSuggestion'

import * as styles from './ApplicantCreditCheckSuggestions.module.css'

function ApplicantCreditCheckSuggestions({
  applicantData,
  isPreview,
  suggestions,
}) {
  const { handleClickDismiss, handleClickReview, submittingId } =
    useApplicantCreditCheckSuggestion()

  return (
    <div className={styles.ApplicantCreditCheckSuggestions}>
      {suggestions.map(suggestion => (
        <ApplicantCreditCheckSuggestion
          applicantData={applicantData}
          isPreview={isPreview}
          isSubmitting={submittingId === suggestion.id}
          key={suggestion.id}
          suggestion={suggestion}
          onClickDismiss={handleClickDismiss}
          onClickReview={handleClickReview}
        />
      ))}
    </div>
  )
}

export default ApplicantCreditCheckSuggestions
